import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router";
import { StringService, _ } from "src/services";
import { Packages, PackagesAction } from "src/store";
import { Close, GreenCheck } from "../svg";

export const PaymentDiscount: React.FC = () => {

    //#region dependencies

    const { orderId }: any = useParams();
    const dispatch = useDispatch();
    const packages: Packages = useSelector((state: any) => state.PackagesState);

    //#endregion

    //#region states

    const [code, setCode] = useState("");
    const [discountDisabled, serDiscountDisabled] = useState(false);

    //#endregion

    //#region effects

    useEffect(() => {

        if (packages.order) {
            setCode(packages.order.discountCode);
            serDiscountDisabled(!!packages.order.discountCode);
        }

    }, [packages.order]);

    //#endregion

    //#region methods

    const onCodeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setCode(e.target.value);
    };

    const addDicount = () => {
        if (packages.loading) return;
        dispatch(PackagesAction.addDiscount(+orderId, StringService.normalize(code)));
    };

    const removeDicount = () => {
        dispatch(PackagesAction.removeDiscount(+orderId));
    };

    const discountCodeKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.code === 'Enter') addDicount();
    };


    //#endregion


    const { discountCode } = packages.order || {};

    return (
        <div className="payment-bill-info d-flex flex-column">
            <div className="payment-box__title py-2">{_("discountCode")}</div>
            {
                !discountCode &&
                <>
                    <div className="payment-discount-code-box d-flex">
                        <input
                            onKeyDown={discountCodeKeyDown}
                            type="text"
                            disabled={discountDisabled}
                            value={code}
                            onChange={onCodeChange}
                            placeholder={_("discountCodePlaceholder")}
                        />
                        <button
                            onClick={addDicount}
                            disabled={packages.loading || !code}
                            className={`${packages.loading || !code ? " disabled" : ""}`}
                        >{_("save")}</button>
                    </div>
                </>
            }
            {
                !!discountCode &&
                <>
                    <div className="dicount-message d-flex">
                        <span className="flex-1 d-flex">
                            <GreenCheck size={22} />
                            {_("discountApplied").replaceAll("{code}", discountCode || "")}
                        </span>
                        <button
                            onClick={removeDicount}
                            disabled={packages.loading}
                            className={`remove-discount ${packages.loading ? " disabled" : ""}`}
                        >
                            <Close />
                            <span>{_("removeDiscount")}</span>
                        </button>
                    </div>
                </>
            }
        </div>

    );

};